//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  IDefaultInstagramAccount,
  IInstagramAccountSessionState,
  IInstagramAccountState,
} from '@instagram-account/redux/account/instagramAccountModel';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import { IMetadataResponse } from '@models/MetricsGatewayApiModels';
import { SliceNames } from '@redux/SliceNames';

const initialState: IInstagramAccountState = {
  defaultInstagramAccount: undefined,
  isFetchingDefaultInstagramAccount: false,
  insightsMetadata: undefined,
  instagramBusinessAccount: undefined,
  errors: {},
};

const { actions, reducer } = createSlice({
  name: SliceNames.InstagramAccount,
  initialState,
  reducers: {
    requestDefaultInstagramAccount(state) {
      state.isFetchingDefaultInstagramAccount = true;
    },

    receiveDefaultInstagramAccountSucceeded(
      state,
      action: PayloadAction<{
        defaultInstagramAccount: IDefaultInstagramAccount;
        businessAccountId: InstagramBusinessAccountId;
      }>,
    ) {
      state.defaultInstagramAccount = action.payload.defaultInstagramAccount;
      state.instagramBusinessAccount = action.payload.businessAccountId;
      state.isFetchingDefaultInstagramAccount = false;
    },

    receiveDefaultInstagramAccountFailed(state, action: PayloadAction<string>) {
      state.isFetchingDefaultInstagramAccount = false;
      state.errors = {
        fetchDefaultInstagramAccountError: action.payload,
      };
    },

    setSessionStateInfo(
      state,
      action: PayloadAction<IInstagramAccountSessionState>,
    ) {
      state.sessionState = action.payload;
    },

    updateInsightsMetadata(state, action: PayloadAction<IMetadataResponse>) {
      state.insightsMetadata = action.payload;
    },
  },
});

export const {
  setSessionStateInfo,
  updateInsightsMetadata,
  requestDefaultInstagramAccount,
  receiveDefaultInstagramAccountFailed,
  receiveDefaultInstagramAccountSucceeded,
} = actions;

export default reducer;
